module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAABCAYAAADJsB7sAAAAAXNSR0IArs4c6QAAABBJREFUCB1jvHTn3n+GAQAApJQDjfjPiccAAAAASUVORK5CYII="